// src/admin/components/AdminLayout.js
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';

const AdminLayout = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="relative min-h-screen md:flex">
            {/* Sidebar */}
            <AdminSidebar isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />

            {/* Main Content Wrapper */}
            <div className="flex-1">
                {/* Header */}
                <AdminHeader setSidebarOpen={setSidebarOpen} />

                {/* Page Content */}
                <main className="p-4 md:p-6 bg-gray-100">
                    {/* Outlet component renders the current page (e.g., Dashboard, ManageGallery) */}
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;